"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const FormGroup_1 = __importDefault(require("@mui/material/FormGroup"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("./styles");
const InputLabel_1 = __importDefault(require("../InputLabel"));
const StyledTextField = (0, styled_components_1.default)(TextField_1.default) `
  ${styles_1.textInputStyles};
`;
/**
 * A generic text input component with form label.
 * Extends [MUI's TextField component](https://v4.mui.com/components/text-fields/).
 * */
const TextInput = ({ label, 
// eslint-disable-next-line @typescript-eslint/no-shadow
InputLabelProps, optional, ...rest }) => ((0, jsx_runtime_1.jsxs)(FormGroup_1.default, { children: [label && ((0, jsx_runtime_1.jsx)(InputLabel_1.default, { label: label, optional: optional, ...InputLabelProps })), (0, jsx_runtime_1.jsx)(StyledTextField, { variant: "outlined", ...rest })] }));
exports.default = TextInput;
//# sourceMappingURL=index.js.map